import { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject, Injectable } from '@angular/core';

import { LoginRedirectService } from './login-redirect.service';
import { LoggedInService } from './logged-in.service';

@Injectable()
export class AuthGuardService {
  constructor(
    private loggedInService: LoggedInService,
    private loginRedirect: LoginRedirectService
  ) {}

  canActivate(targetUrl?: string): boolean {
    if (!this.loggedInService.isLoggedIn()) {
      // In-app navigations haven't updated document.location yet, so the target route
      // must be taken from the router state rather than the (still stale) current URL.
      this.loginRedirect.redirectWithState(targetUrl);
      return false;
    }
    return true;
  }
}

export const authGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  return inject(AuthGuardService).canActivate(state.url);
};
